import React, { Component } from 'react';
import css from '../css/module/charting-config.css';
import ColorPicker from './charting/ColorPicker';

class ChartColorSelect extends Component {
  constructor(props) {
    super(props);
    this.colorDropdown = React.createRef();
    this.isOutsideColorDropdown = this.isOutsideColorDropdown.bind(this);
    this.handleUserWindowClick = this.handleUserWindowClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.handleUserWindowClick);
  }

  componentWillUnmount() {
    // cleanup
    window.removeEventListener('click', this.handleUserWindowClick);
  }

  handleUserWindowClick(e) {
    if (e.target === this._colorIcon || !this.props.colorOpened) {
      return;
    }
    if (this.isOutsideColorDropdown(e)) {
      // is outside, so close dropdown
      this.props.setColorOpened();
    }
  }

  isOutsideColorDropdown(e) {
    const dropdown = this.colorDropdown.current;
    const dropdownDimensions = dropdown.getBoundingClientRect();
    // MouseEvent has clientX and clientY
    const x = e.clientX;
    const y = e.clientY;
    return (
      x < dropdownDimensions.x ||
      y < dropdownDimensions.y ||
      x > dropdownDimensions.x + dropdownDimensions.width ||
      y > dropdownDimensions.y + dropdownDimensions.height
    );
  }

  render() {
    const {
      label,
      hex,
      onChangeColor,
      colorOpened,
      setColorOpened,
      style,
      index,
    } = this.props;

    const addedStyle = style || {};

    return (
      <div className={css.colorRow} key={index} style={addedStyle}>
        <span>{label || 'NULL'}</span>
        <div
          ref={(div) => (this._colorIcon = div)}
          className={css.colorDropdown}
          style={{ background: hex }}
          onClick={setColorOpened}
        />
        {!colorOpened ? null : (
          <div
            ref={this.colorDropdown}
            style={{
              position: 'absolute',
              right: '0px',
              top: '23px',
              zIndex: 2,
            }}
          >
            <ColorPicker color={hex} onChange={onChangeColor} />
          </div>
        )}
      </div>
    );
  }
}

export default ChartColorSelect;
